import {
    DTOCardFormField, NestedField,
} from 'app/types/form.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LoggerMode, LoggerStatus,
} from 'app/enums/label.enums'
import {
    LoggerResponse,
} from '../Loggers.types'

type LoggerGatewayFields = {
    'gateway.locationRemark': string,
    'gateway.location.id': string,
    'gateway.areaName': string,
    'gateway.gatewayImeiMac': string,
}

type LoggerOverviewFields = LoggerResponse & LoggerGatewayFields

export const loggerTransmissionFields: NestedField<keyof LoggerResponse>[] = [
    {
        name: 'temperatureTransmissionRateSecondsStationary',
        componentName: 'IntegerInput',
        labelKey: 'TEMPERATURE_TRANSMISSION_RATE_SECONDS_STATIONARY',
    },
    {
        name: 'temperatureTransmissionRateSecondsMoving',
        componentName: 'IntegerInput',
        labelKey: 'TEMPERATURE_TRANSMISSION_RATE_SECONDS_MOVING',
    },
    {
        name: 'measurementIntervalSeconds',
        componentName: 'IntegerInput',
        labelKey: 'LOGGER_MEASUREMENT_INTERVAL_SECONDS',
    },
    {
        name: 'lastActivatedOn',
        componentName: 'DateTimeSelect',
        disabled: true,
        labelKey: 'LAST_ACTIVATED_ON',
    },
    {
        name: 'lastCalibratedOn',
        componentName: 'DateTimeSelect',
        disabled: true,
        labelKey: 'LAST_CALIBRATED_ON',
    },
]

export const loggerGatewayCardFields: DTOCardFormField<keyof LoggerGatewayFields> = {
    id: 'gateway',
    title: 'Last Connected Gateway',
    className: 'gateway',
    labelKey: 'Logger.gateway',
    fields: [{
        id: 'gateway-column1',
        fields: [
            {
                name: 'gateway.gatewayImeiMac',
                componentName: 'InputSingleline',
                disabled: true,
                labelKey: 'GATEWAY',
            },
            {
                name: 'gateway.location.id',
                componentName: 'LocationSelector',
                disabled: true,
                labelKey: 'LOCATION',
            },
            {
                name: 'gateway.areaName',
                componentName: 'InputSingleline',
                disabled: true,
                labelKey: 'AREA_NAME',
            },
            {
                name: 'gateway.locationRemark',
                componentName: 'LongText',
                disabled: true,
                labelKey: 'LOCATION_REMARK',
            },
        ],
    }],
}

const loggerFields = ({
    containerSerialNumber,
    containerLink,
    getAllowedValues,
}: {
    containerSerialNumber: string | null,
    containerLink: string | null,
    getAllowedValues: (value: Record<string, string>) => Record<string, string>,
}): DTOCardFormField<keyof LoggerOverviewFields>[] => {
    return [
        {
            id: 'loggers',
            title: 'Loggers',
            className: 'loggers',
            fields: [
                {
                    id: 'loggers-column1',
                    fields: [
                        {
                            name: 'loggerNumber',
                            componentName: 'InputSingleline',
                            label: 'LOGGER',
                        },
                        {
                            name: 'loggerQrCode',
                            componentName: 'InputSingleline',
                            label: 'LOGGER_QR_CODE',
                        },
                        {
                            name: 'containerSerialNumber',
                            componentName: 'SkyNetLink',
                            link: containerLink,
                            text: containerSerialNumber,
                            type: TypeLink.INTERNAL_WITH_ICON,
                            size: SizeLink.S,
                            labelKey: 'CONTAINER_SERIAL_NUMBER',
                        },
                        {
                            name: 'loggerStatus',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(LoggerStatus),
                            labelKey: 'LOGGER_STATUS',
                        },
                        {
                            name: 'loggerMode',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(LoggerMode),
                            labelKey: 'LOGGER_MODE',
                        },
                        {
                            name: 'loggerType',
                            componentName: 'LoggerTypeSelector',
                            labelKey: 'LOGGER_TYPE',
                        },
                    ],
                },
                {
                    id: 'loggers-column2',
                    fields: [
                        {
                            name: 'isTestingLogger',
                            componentName: 'Checkbox',
                            labelKey: 'IS_TESTING_LOGGER',
                        },
                        {
                            name: 'hardwareVersion',
                            componentName: 'InputSingleline',
                            labelKey: 'HARDWARE_VERSION',
                        },
                        {
                            name: 'softwareVersion',
                            componentName: 'InputSingleline',
                            labelKey: 'SOFTWARE_VERSION',
                        },
                        {
                            name: 'rentingCompany',
                            componentName: 'CompanyObjectSelector',
                            labelKey: 'RENTING_COMPANY',
                        },
                        {
                            name: 'batteryVoltage',
                            componentName: 'InputSingleline',
                            labelKey: 'BATTERY_VOLTAGE_MV',
                        },
                        {
                            name: 'destinationLocation',
                            componentName: 'LocationObjectSelector',
                            labelKey: 'DESTINATION_LOCATION',
                        },
                    ],
                },
                {
                    id: 'loggers-column3',
                    fields: loggerTransmissionFields,
                },
            ],
        },
        loggerGatewayCardFields,
    ]
}

export default loggerFields
